module.exports = __webpack_public_path__ + "static/Home4_Hover-04c2e2713ad244c28c087b1e4329df8c.png";